import { render } from "./FeedbackDetail.vue?vue&type=template&id=a0760352&scoped=true"
import script from "./FeedbackDetail.vue?vue&type=script&lang=js"
export * from "./FeedbackDetail.vue?vue&type=script&lang=js"

import "./FeedbackDetail.vue?vue&type=style&index=0&id=a0760352&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0760352"]])

export default __exports__